import { Controller } from "@hotwired/stimulus";

// Rola suave até o elemento com o id em data-scroll-to-target-id-value (sem onclick inline, por causa da CSP).
export default class extends Controller {
  static values = { targetId: String };

  scroll(event) {
    event.preventDefault();
    document.getElementById(this.targetIdValue)?.scrollIntoView({ behavior: "smooth" });
  }
}
